import { FC } from 'react';
import { Box, Container, Link, Typography } from '@mui/material';

export const NotFound: FC = () => {
	return (
		<Container style={{ padding: '40px 20px 0 20px' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: { md: 'row', xs: 'column' },
					alignItems: 'start',
					justifyContent: 'center',
					gap: '20px',
				}}
			>
				<Typography
					sx={{
						fontSize: { md: 150, xs: 80 },
						fontWeight: 600,
						marginTop: '-45px',
					}}
				>
					404
				</Typography>
				<Box>
					<Typography
						sx={{
							fontSize: { md: 40, xs: 30 },
							fontWeight: 600,
						}}
					>
						Declaration of Conformity Not Found
					</Typography>
					<Typography
						sx={{
							fontSize: { sm: 20, xs: 14 },
							fontWeight: 600,
						}}
					>
						The requested Declaration of Conformity could not be located in the EAS database.
					</Typography>

					<Typography sx={{ fontSize: { sm: 20, xs: 14 }, fontWeight: 500 }}>
						The product may not yet be registered.
					</Typography>
					<Typography sx={{ fontSize: { sm: 20, xs: 14 }, fontWeight: 500 }}>
						The Declaration of Conformity may be under review or incomplete.
					</Typography>
					<Typography sx={{ fontSize: { sm: 20, xs: 14 }, fontWeight: 500 }}>
						The URL may be incorrect.
					</Typography>
					<Box sx={{ marginTop: '20px' }}>
						<Typography sx={{ fontSize: { sm: 20, xs: 14 }, fontWeight: 500 }}>
							Contact the manufacturer or Authorized Representative for further assistance.
						</Typography>

						<Typography sx={{ fontSize: { sm: 20, xs: 14 }, fontWeight: 500 }}>
							For urgent inquiries, reach out to EAS Compliance at{' '}
							<Link
								href="mailto:gpsr@easproject.com"
								sx={{
									color: 'primary',
									fontWeight: 600,
									textDecoration: 'none',
								}}
							>
								gpsr@easproject.com
							</Link>
							.
						</Typography>
					</Box>
				</Box>
			</Box>
		</Container>
	);
};
